import request from '@/middleware/request'

const synthesis = (data, responseType) => {
  return request({
    url: `/synthesis`,
    method: 'post',
    responseType: responseType || undefined,
    data
  })
}

const getTtsChoice = () => {
  return request({
    url: `/synthesis/ttsChoice`,
    method: 'get'
  })
}

const getTtsUrl = data => {
  return request({
    url: `/synthesis/getTtsUrl`,
    method: 'post',
    data
  })
}

export default {
  synthesis,
  getTtsChoice,
  getTtsUrl
}
